import { useState } from "react"
import Select from 'react-select'

/* form */
import Input from "../../../shared/components/form/input"
import selectStyles from "../../../shared/css/SelectStyle"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"

// Unidade livre pra cobrir a variedade de itens do Estoque Geral (não é só tecido/aviamento).
const UNIT_OPTIONS = [
    { selectName: "unit", value: "un", label: "Unidade" },
    { selectName: "unit", value: "m", label: "Metro" },
    { selectName: "unit", value: "kg", label: "Quilo" },
    { selectName: "unit", value: "l", label: "Litro" },
    { selectName: "unit", value: "cx", label: "Caixa" },
    { selectName: "unit", value: "pct", label: "Pacote" },
    { selectName: "unit", value: "rl", label: "Rolo" },
]

function FormStockItem({ handleSubmit, itemData, btnText, btCancelAction, title }) {
    const isEdit = !!itemData
    const [item, setItem] = useState(itemData || {})

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value })
    }

    function handleSelectChange(selectedOption) {
        setItem({ ...item, [selectedOption.selectName]: selectedOption })
    }

    function submit(e) {
        e.preventDefault()
        e.stopPropagation()
        handleSubmit(item)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Nome do Item"
                            type="text"
                            name="name"
                            placeholder="ex.: Saco plástico 30x40"
                            handleOnChange={handleChange}
                            value={item.name || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Unidade:</label>
                        <Select
                            options={UNIT_OPTIONS}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={item.unit || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>

                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Categoria (opcional)"
                            type="text"
                            name="category"
                            placeholder="ex.: Embalagem, Limpeza..."
                            handleOnChange={handleChange}
                            value={item.category || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Estoque mínimo"
                            type="number"
                            name="minQuantity"
                            placeholder="0.00"
                            handleOnChange={handleChange}
                            value={item.minQuantity ?? ''}
                        />
                    </div>
                    {!isEdit && (
                        <div className="fl-col-mid form-group">
                            <Input
                                text="Quantidade inicial (opcional)"
                                type="number"
                                name="initialQuantity"
                                placeholder="0.00"
                                handleOnChange={handleChange}
                                value={item.initialQuantity || ''}
                            />
                        </div>
                    )}
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormStockItem
